import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface AgreementData {
  signature: string;
  date: string;
  isAgreed: boolean;
}

interface AgreementComponentProps {
  onChange: (data: AgreementData) => void;
}

export const AgreementComponent: React.FC<AgreementComponentProps> = ({
  onChange,
}) => {
  const location = useLocation();
  // パスが '/ja' で始まる場合は日本語、それ以外は英語とする
  const lang = location.pathname.startsWith('/ja') ? 'ja' : 'en';

  const guaranteeEntrustment =
    lang === 'en'
      ? 'https://www.ithinkrent.co.jp/wordpress/wp-content/themes/ashe/assets/download/i-smile-SA_GA_eng.pdf'
      : 'https://www.ithinkrent.co.jp/wordpress/wp-content/themes/ashe/assets/download/i-smile-SA_GA.pdf';

  const [isAgreed, setIsAgreed] = useState(false);
  const [signature, setSignature] = useState('');
  const [date, setDate] = useState('');

  useEffect(() => {
    onChange({
      signature,
      date,
      isAgreed,
    });
  }, [signature, date, isAgreed, onChange]);

  return (
    <div className="rounded-md">
      <h2 className="text-lg font-bold border-b-2 border-gray-800 pb-2 mb-4">
        ■保証委託にあたっての同意事項
      </h2>

      <div className="mb-6">
        <h3 className="font-bold mb-2">＜保証委託について＞</h3>
        <p className="text-sm mb-2">
          （1）申込者は、
          <a
            href={guaranteeEntrustment}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            「保証委託契約約款」
          </a>
          及び
          <a
            href="https://www.ithinkrent.co.jp/wordpress/wp-content/themes/ashe/assets/download/privacy_agreement.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            「個人情報取扱いに関する約款」
          </a>
          に同意の上、保証委託契約を申込みます。
        </p>
        <p className="text-sm mb-2">
          （2）お申込み後、下記メールアドレス宛にカード登録用のURLをお送りします。そちらからご登録をお願いします。
        </p>
        <p className="text-sm mb-2">
          また、東急株式会社及びアイ・シンクレント株式会社より、申込者様、勤務先、緊急連絡先にご連絡させていただく場合がございます。
        </p>
        <p className="text-sm mb-2">
          （3）「本申込書」に事実と異なる、あるいは虚偽の記載があった場合、申込は無効となり、また契約を解除されても何らの異議を申し立てません。
        </p>
      </div>

      <div className="mb-6">
        <h3 className="font-bold mb-2">＜ご署名＞</h3>
        <p className="text-sm mb-2">
          私は、本申込ページに記載した内容に相違のないこと及び上記（1）～（8）の内容を承認の上、「ご請求について」に記載された金額を、上記メールアドレスに送信されたURLより私が登録したクレジットカードによりお支払いが確定することを利用して決済されることに同意し、保証委託契約を申込みます。
        </p>

        {/* 日付 */}
        <div className="mb-4">
          <label className="block text-sm mb-1" htmlFor="date">
            ご記入日 *
          </label>
          <input
            type="date"
            id="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            className="border border-gray-300 rounded-md w-full p-2 text-sm"
          />
        </div>

        {/* 署名 */}
        <div className="mb-4">
          <label className="block text-sm mb-1" htmlFor="signature">
            申込者本人署名 *
          </label>
          <input
            type="text"
            id="signature"
            placeholder="例）東急 太郎"
            value={signature}
            onChange={(e) => setSignature(e.target.value)}
            className="border border-gray-300 rounded-md w-full p-2 text-sm"
          />
        </div>

        {/* チェックボックス */}
        <div>
          <label className="flex items-center">
            <input
              type="checkbox"
              className="w-4 h-4 border border-gray-300 rounded mr-2"
              checked={isAgreed}
              onChange={(e) => setIsAgreed(e.target.checked)}
            />
            <span className="text-sm">
              個人情報の取り扱いについて、同意の上送信します。
            </span>
          </label>
        </div>
      </div>
    </div>
  );
};
